import { AsyncCall } from 'async-call-rpc';
import { WorkerChannel } from 'async-call-rpc/utils/web/worker';
import type { server } from './worker';

const worker = new Worker(new URL('./worker.ts', import.meta.url), {
  name: 'sqlite-worker',
});

const rpc = AsyncCall<typeof server>({}, { channel: new WorkerChannel(worker) });

function test() {}

test();

export { rpc };
